<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<img class="bg" src="../../assets/img_public/job/block_bg01_h5.webp"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				/>
				<div class="msg_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">加入库尔</div>
					<div class="tit">一起改变全球诊断</div>
					<div class="txt_box">
						<div class="txt">我们是一家人&ensp;包容&ensp;&&ensp;取代</div>
						<div class="txt">欢迎A咖&ensp;断舍离B类</div>
					</div>
					<div v-if="navList.length > 0" class="btn_box">
						<div v-for="(value, index) in navList" :key="index" class="h5_public_btn" @click="btnClick(value)">{{ value.title }}</div>
					</div>
				</div>
			</div>
			<!--banner-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			navList: [],
		}
	},
	created(){
		let that = this;
		if(sessionStorage.getItem('navList')) {
			that.navList = JSON.parse(sessionStorage.getItem('navList'))[5].children;
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击按钮
		btnClick(value) {
			let that = this;
			that.$router.push({ name: 'JobList', params: { jobId: value.url, } });
			window.location.reload();
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	.banner_box{
		width: 100%;
		position: relative;
		.msg_box{
			width: 100%;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			text-align: center;
			.btn_box{
				padding-top: 200px;
				.h5_public_btn{
					margin: 0 20px 0 20px;
					padding: 8px 10px;
					color: #ffffff;
					border: 1px solid #ffffff;
				}
			}
			.txt_box{
				padding-top: 20px;
				.txt{
					color: #A50073;
				}
			}
			.tit{
				font-size: 24px;
				color: #A50073;
				font-weight: bold;
			}
		}
		.bg{
			width: 100%;
		}
	}
}
</style>